import React, { createContext, useState } from "react";

export const StateContext = createContext();

export default function StateProvider({ children }) {
    const [state, setState] = useState({
        loading: false,
        success: false,
        error: false,
        reset: false,
    });

    return (
        <StateContext.Provider value={{ state, setState }}>
            {children}
        </StateContext.Provider>
    );
}
